import React from 'react';
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { OrthographicCamera } from '@react-three/drei';
import NavBar from './NavBar.jsx';
import AboutMe from './AboutMe.jsx';
import Projects from './Projects.jsx';
import TechMarquee from './components/TechMarquee';
import ExperienceSection from './components/ExperienceSection';

function App() {
  return (
    <div>
      <NavBar style={{ position: 'sticky'}}/>
      
      <section id="about-me" style={{ 
        minHeight: '100vh', 
        marginTop: '10px', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between',
        '@media (max-width: 768px)': {
          minHeight: 'auto',
          paddingBottom: '2rem'
        }
      }}>
        <AboutMe />
        <div style={{ marginTop: 'auto' }}>
          <TechMarquee />
        </div>
      </section>
      
      <section id="experience" style={{ minHeight: '100vh' }}>
        <ExperienceSection />
      </section>
      
      <section id="projects" style={{ height: '100vh' }}>
        <Projects />
      </section>
      
      <section id="technologies" style={{ height: '100vh' }}>
        <div style={{ height: '100%' }}>
          <Canvas style={{ height: '100%', width: '100%'}}>
            <OrthographicCamera
              makeDefault
              position={[0, 2.2, 12]}
              zoom={100}
              near={0.1}
              far={1000}
            />
            <Experience />
          </Canvas>
        </div>
      </section>
    </div>
  );
}

export default App;
